// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0ch06d5qiMl5uhPKud5","section":"mpRS66JknyV3DaFNqvtU"};